import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { settingsApi } from "@/integrations/mysql/client";

export const PAGE_VISIBILITY_KEYS = {
  blog:          "page_blog_visible",
  servicos:      "page_servicos_visible",
  depoimentos:   "page_depoimentos_visible",
  jornada:       "page_jornada_visible",
  nossaHistoria: "page_nossa_historia_visible",
  faq:           "page_faq_visible",
  imprensa:      "page_imprensa_visible",
} as const;

export type PageKey = keyof typeof PAGE_VISIBILITY_KEYS;

export function usePageVisibility() {
  const queryClient = useQueryClient();

  const { data: settings = [] } = useQuery({
    queryKey: ["site-settings"],
    queryFn: settingsApi.list,
    staleTime: 30_000,
  });

  const mutation = useMutation({
    mutationFn: ({ key, visible }: { key: string; visible: boolean }) =>
      settingsApi.update(key, visible ? "true" : "false"),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["site-settings"] }),
  });

  const isVisible = (key: string): boolean => {
    const s = settings.find((s) => s.key === key);
    // default true when setting doesn't exist yet
    return s ? s.value !== "false" : true;
  };

  const setVisible = (key: string, visible: boolean) =>
    mutation.mutate({ key, visible });

  return { isVisible, setVisible, isUpdating: mutation.isPending };
}
